import { TableSize } from '../types';

export const TABLE_CONFIG = {
  SIZES: ['l', 'm', 's'] as const satisfies readonly TableSize[],
  PAGE_SIZE: 10,
  COLUMNS: [
    'date',
    'time',
    'executedBy',
    'status',
    'zoneAssignment',
    'assignmentDate',
    'actions',
  ] as const,
} as const;


export const SEARCH_CONFIG = {
  DEBOUNCE_TIME: 300,
} as const;

export const REGEX_PATTERNS = {
  UUID: /^[0-9a-fA-F\-]+$/,
} as const;

export const DATE_FORMATS = {
  DATE: 'DD/MM/YYYY',
  TIME: 'HH:mm',
} as const;
